<template>
    <div class="absolute flex h-full w-full">
        <div class="my-auto ml-2 flex w-3/4 flex-nowrap whitespace-nowrap">
            <div
                class="my-auto mr-2 h-2 w-2 rounded-full"
                :class="data.chartData.colour"
            ></div>
            <p class="truncate text-sm font-normal">
                {{ data.name }}
            </p>
        </div>
    </div>
</template>
<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
});
</script>
